import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { GridCellProps } from '@progress/kendo-react-grid'
import { IPageProps, ICustomColumn } from 'types'
import { MOBILE_GRID_WIDTH } from 'core/consts'
import SAGrid from 'components/Grid/SAGrid'
import { PageHeader } from 'components'
import { V1ApiReportsClient } from 'core/http-common'
import toast from 'core/toast'
import { OfferUpSalesDto } from '@v1ReportsApi'
import { AppDispatch } from 'state/store'
import { endLoadingAction, startLoadingAction } from 'state/actions/appActions'

const OfferUpSalesPage = ({ title }: IPageProps) => {
    const dispatch = useDispatch<AppDispatch>()
    const [gridData, setGridData] = useState<OfferUpSalesDto[]>([])

    const OverviewCell = (props: GridCellProps) => {

        const dealerID = props.dataItem.dealerID
        const dealerName = props.dataItem.dealerName
        const dateEnrolled = props.dataItem.dateEnrolled
        const address1 = props.dataItem.dealeraddress1Name
        const offerUp249 = props.dataItem.offerUp249
        const offerUp349 = props.dataItem.offerUp349
        const offerUp449 = props.dataItem.offerUp449

        return (
            <td>
                {dealerID}<br />
                {dealerName}<br />
                {dateEnrolled}<br />
                {address1}<br />
                {offerUp249}<br />
                {offerUp349}<br />
                {offerUp449}
            </td>
        )
    }

    const initialColumns: ICustomColumn[] = [
        { field: 'dealerId', title: 'Dealer ID', minGridWidth: MOBILE_GRID_WIDTH + 1 },
        { field: 'dealerName', title: 'Dealer Name', sortable: false, minGridWidth: MOBILE_GRID_WIDTH + 1 },
        { field: 'dateEnrolled', title: 'Date Enrolled', sortable: false, minGridWidth: MOBILE_GRID_WIDTH + 1, format: '{0:d}' },
        { field: 'address1', title: 'Address1', sortable: false, minGridWidth: MOBILE_GRID_WIDTH + 1 },
        { field: 'offerUp249', title: 'Offer Up $249', sortable: false, minGridWidth: MOBILE_GRID_WIDTH + 1 },
        { field: 'offerUp349', title: 'Offer Up $349', sortable: false, minGridWidth: MOBILE_GRID_WIDTH + 1 },
        { field: 'offerUp449', title: 'Offer Up $449', sortable: false, minGridWidth: MOBILE_GRID_WIDTH + 1 },
    ]

    // TODO: TempData please replace with API Call
    const tempGridData = [
        { dealerID: '1', dealerName: 'Demo Dealer', dateEnrolled: '8/5/2024', address1: '123 example', offerUp249: '1', offerUp349: '1', offerUp449: '1' },
        { dealerID: '2', dealerName: 'Otto Dealer', dateEnrolled: '3/9/2024', address1: '123 example', offerUp249: '2', offerUp349: '2', offerUp449: '2' },
        { dealerID: '4', dealerName: 'Unlimited Motors', dateEnrolled: '10/5/2024', address1: '123 example', offerUp249: '3', offerUp349: '3', offerUp449: '3' },
    ]

    const getData = async () => {
        try {
            await dispatch(startLoadingAction())

            const result = await V1ApiReportsClient.getOfferUpSalesReport()
            if (result && result.data) {
                setGridData(result.data)
            }

        } catch (error) {
            toast.responseErrors(error)

        }
        finally {
            await dispatch(endLoadingAction())
        }
    }

    useEffect(() => {
        getData()
    }, [])


    return (
        <div>
            <PageHeader title={title}></PageHeader>

            {gridData && gridData.length > 0 &&

                <SAGrid
                    columns={initialColumns}
                    data={gridData}
                    defaultSort={[{ field: 'dealerName', dir: 'asc' }]}
                    features={{
                        pageable: undefined,
                        sortable: undefined,
                        filterable: undefined,
                        exportToPDF: undefined,
                        exportToExcel: true,
                        reorderColumns: undefined,
                        simpleSearch: undefined,
                        title: undefined,
                        actions: undefined,
                    }}
                />
            }

        </div>
    )
}
export default OfferUpSalesPage